(() => {
  if (window.completeLookSliderLoaded) {
    window.initializeCompleteLookSliders?.();
    return;
  }

  window.completeLookSliderLoaded = true;

class CompleteLookSlider {
  constructor(container) {
    this.container = container;
    this.rail = container.querySelector('[data-complete-look-rail]');
    this.controls = container.querySelector('.complete-look__controls');
    this.previousButton = container.querySelector('[data-complete-look-previous]');
    this.nextButton = container.querySelector('[data-complete-look-next]');
    this.cards = Array.from(container.querySelectorAll('.complete-look-card'));
    this.frame = null;

    if (!this.rail || !this.controls || !this.previousButton || !this.nextButton || this.cards.length < 2) return;

    this.previousButton.addEventListener('click', () => this.scroll(-1));
    this.nextButton.addEventListener('click', () => this.scroll(1));
    this.rail.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true });

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.rail);
    } else {
      window.addEventListener('resize', () => this.update());
    }

    this.update();
  }

  scheduleUpdate() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.update();
    });
  }

  scroll(direction) {
    const card = this.cards[0];
    const styles = window.getComputedStyle(this.rail);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.rail.scrollBy({
      left: direction * (card.getBoundingClientRect().width + gap),
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  }

  update() {
    const maximumScroll = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
    const hasOverflow = maximumScroll > 2;
    const currentScroll = Math.max(0, this.rail.scrollLeft);

    this.controls.hidden = !hasOverflow;
    this.previousButton.disabled = !hasOverflow || currentScroll <= 2;
    this.nextButton.disabled = !hasOverflow || currentScroll >= maximumScroll - 2;
  }
}

const initializeCompleteLookSliders = (root = document) => {
  root.querySelectorAll('[data-product-info-complete-look]').forEach((container) => {
    if (container.dataset.completeLookInitialized === 'true') return;
    container.dataset.completeLookInitialized = 'true';
    new CompleteLookSlider(container);
  });
};

window.initializeCompleteLookSliders = initializeCompleteLookSliders;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeCompleteLookSliders());
} else {
  initializeCompleteLookSliders();
}

document.addEventListener('shopify:section:load', (event) => initializeCompleteLookSliders(event.target));
})();
